module.exports = require('./dist/time/time.js');
